import { isFeatureExpired } from './SelectionDeadlineUtility';
import IsNullOrUndefined from "../utils/ObjectUtils";
import IsNullOrEmpty from "../utils/StringUtils";

export const FeatureSelectionUtility = {

    ApplyFeatureSelectionString: (categories, featureSelectionString) => {
        const featuresSelected = featureSelectionString.split('-');
        featuresSelected.forEach(featureSelected => {
            categories.forEach((category) => {
                const featureInCategory = category.features.find(feature => feature.id.toString() === featureSelected);
                if (featureInCategory !== undefined)
                {
                    category.selected_feature = featureInCategory.id;
                }
            });
        });
    },
    CreateFeatureSelectionString: (categories) => {
        let response = "";

        categories.forEach((category) => {
            const currentFeature = category.features.find(feature => feature.id === category.selected_feature);

            if (!IsNullOrUndefined(currentFeature) && !isFeatureExpired(currentFeature)) {
                if (IsNullOrEmpty(response)) {
                    response = currentFeature.id;
                } else {
                    response = response + "-" + currentFeature.id;
                }
            }
        });

        return response;
    },
    CreateFeatureSelectionExcludingDisabledString: (categories) => {
      let response = "";

      categories.forEach((category) => {
        const currentFeature = category.features.find(feature => feature.id === category.selected_feature);

        if (!IsNullOrUndefined(currentFeature) && !category.disabled && !currentFeature.disabled && !isFeatureExpired(currentFeature)) {
          if (IsNullOrEmpty(response)) {
            response = currentFeature.id;
          } else {
            response = response + "-" + currentFeature.id;
          }
        }
      });

      return response;
    },
    CreateFeatureSelection: (categories) => {
        let response = [];

        categories.forEach((category) => {
            const currentFeature = category.features.find(feature => feature.id === category.selected_feature);

            if (currentFeature !== undefined && !isFeatureExpired(currentFeature)) {
                const featureSelection = {
                    look_type: category.look_type,
                    id_categories: category.id,
                    id_features: currentFeature.id
                };
                response.push(featureSelection);
            }
        });

        return response;
    },
    ApplyFeatureSelection: (categories, featuresSelection) => {
        categories.forEach((category) => {
            const newFeatureSelection = featuresSelection.find(featureSelection => featureSelection.id_categories === category.id);
            if (newFeatureSelection !== undefined)
            {
                // double check feature exists in category
                const featureInCategory = category.features.find(feature => feature.id === newFeatureSelection.id_features);
                if (featureInCategory !== undefined)
                {
                    category.selected_feature = newFeatureSelection.id_features;
                } else {
                    // apply first feature in category as selected
                    category.selected_feature = category.features[0].id;
                }
            } else {
                // apply first feature in category as selected
                category.selected_feature = category.features[0].id;
            }
        });

        return categories;
    },
};
